import { RootState } from "@/redux/store";

export const operatorBrandingSelector = (state: RootState) => state.marketing.operatorBranding;
export const registrationSelector = (state: RootState) => state.marketing.registration;
